class PosChartController {
  /* @ngInject */
  constructor() {
    this.name = 'PosChartController';
  }
}

export default PosChartController;



/** WEBPACK FOOTER **
 ** ./client/app/components/dashboard/pos/chart/chart.controller.js
 **/